import { render, staticRenderFns } from "./WorkOrderOverdueTable.vue?vue&type=template&id=264da626&scoped=true"
import script from "../../../scripts/partials/dashboard-charts/WorkOrderOverdueTable.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/dashboard-charts/WorkOrderOverdueTable.js?vue&type=script&lang=js&external"
import style0 from "./WorkOrderOverdueTable.vue?vue&type=style&index=0&id=264da626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264da626",
  null
  
)

export default component.exports